import React from 'react';
import { BrowserRouter, Switch } from "react-router-dom";
import Route from './Route'
import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import Dashboard from '../pages/Dashboard';
import ForfotPassword from '../pages/ForgotPassword';
import ResetPass from '../pages/ResetPass';
import Perfil from '../pages/Perfil';
import Alunos from '../pages/Alunos';
import Conjuge from '../pages/Conjuge';
import GeraImpresso from '../pages/GeraImpresso';
import GeraImpresso3Ciclos from '../pages/GeraImpresso3Ciclos';
import Page404 from '../pages/404';

const Routes : React.FC = () =>(
    
        <BrowserRouter>
        <Switch>
            <Route path="/" exact component={SignIn} />
            <Route path="/cadastro" component={SignUp} />
            <Route path="/esqueciasenha" component={ForfotPassword} />
            <Route path="/redefinirsenha/:key" component={ResetPass} />
            
            <Route path="/dashboard" component={Dashboard} isPrivate />
            <Route path="/perfil" component={Perfil} isPrivate />
            <Route path="/alunos/:email" component={Alunos} isPrivate />
            <Route path="/conjuge" component={Conjuge} isPrivate />
            <Route path="/geraarquivo" component={GeraImpresso} isPrivate />
            <Route path="/geraarquivo3" component={GeraImpresso3Ciclos} isPrivate />
            <Route path="/" component={Page404} />
        </Switch>
        </BrowserRouter>
    
);

export default Routes;
